import React from 'react'
import PropTypes from 'prop-types'
import { useMemo, useCallback } from 'sb-hooks'

import { Box } from 'components/_new/layout'
import Text from 'components/_new/typography/Text/Text'

import s from './Tags.scss'


const tags = [
  '@gmail.com',
  '@yahoo.com',
  '@hotmail.com',
]


const Tags = ({ email, onTagClick }) => {
  const [ user, domain ] = useMemo(() => email.split('@'), [ email ])

  const visibleTags = useMemo(() => (
    user && !domain ? tags : tags.filter((tag) => (
      new RegExp(`^@${domain}.+`).test(tag)
    ))
  ), [ user, domain ])

  const applyTag = useCallback((tag) => onTagClick(`${user}${tag}`), [ user, onTagClick ])

  return (
    <div className={s.container}>
      {
        visibleTags.map((tag) => (
          <div
            key={tag}
            onMouseDown={() => applyTag(tag)}
            onTouchStart={() => applyTag(tag)}
          >
            <Box
              key={tag}
              className={s.tag}
              pt={4}
              pb={4}
              pl={16}
              pr={16}
            >
              <Text
                message={tag}
                size="14-24"
                semibold
              />
            </Box>
          </div>
        ))
      }
    </div>
  )
}

Tags.propTypes = {
  onTagClick: PropTypes.func.isRequired,
}


export default Tags
